import { optimisticPut } from 'utils/sagas'
import {
  addElement as addElementToLayoutGroup
} from '../redux/layoutGroups'
import {
  add as addBoard
} from 'store/redux/boards'
import _requestAddBoard from 'store/sagas/requestAddBoard'

export default function * requestAddBoard (action) {
  const { layoutId, layoutGroupId, name, background, isTemplate, position, ...payload } = action.payload

  let optimisticAction = null

  if (layoutId !== undefined && layoutGroupId !== undefined) {
    const tempId = `temp-${new Date().getTime()}`

    optimisticAction = yield optimisticPut([
      addBoard({
        id: tempId,
        name,
        background,
        isTemplate,
        hasAccess: true,
        isBusy: true
      }),
      addElementToLayoutGroup({
        key: `${layoutId}-${layoutGroupId}`,
        elementId: tempId,
        type: 'board',
        boardId: tempId,
        position
      })
    ])
  }

  try {
    yield _requestAddBoard({
      ...action,
      payload: {
        name,
        background,
        isTemplate,
        methodArgs: {
          addToLayout: (layoutId && layoutGroupId) ? {
            layoutId,
            groupId: layoutGroupId
          } : undefined,
        },
        ...payload
      }
    })
  } finally {
    if (optimisticAction) {
      yield optimisticAction.revert()
    }
  }
}
